// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-content{display:flex;flex-direction:column;font-weight:500;gap:1rem 0;text-align:justify}.nuxt-content h3{font-size:1.125rem}.nuxt-content p,.nuxt-content span{font-size:.875rem}.nuxt-content a{color:#4568dc}@media screen and (min-width:768px){.nuxt-content p,.nuxt-content span{font-size:1rem}}@media screen and (max-width:768px){.nuxt-content h3{font-size:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
